import { useQuery } from '@tanstack/react-query'

import { axiosInstance } from '../../../helpers'
import {
    DEFAULT_PIPELINE_TABS,
    PipelineTab,
    SeasonPipelineDefinitionResponse,
} from '../LeadsPipeline/pipelineTabs'
import { seasonPipelineDefinitionKey } from './leasingSeasonKeys'

export function useSeasonPipelineTabs(seasonId: number | null | undefined) {
    return useQuery({
        queryKey: seasonPipelineDefinitionKey(seasonId),
        queryFn: async () => {
            const {
                data,
            } = await axiosInstance.get<SeasonPipelineDefinitionResponse>(
                `/outreach/leasing-seasons/${seasonId}/pipeline-definition/`,
            )
            return data
        },
        enabled: seasonId != null,
        staleTime: 60_000,
        placeholderData: {
            definition: null,
            tabs: DEFAULT_PIPELINE_TABS,
        },
    })
}

export function selectPipelineTabs(
    data: SeasonPipelineDefinitionResponse | undefined,
): PipelineTab[] {
    if (!data?.tabs?.length) {
        return DEFAULT_PIPELINE_TABS
    }
    return data.tabs
}
